export default "__VITE_ASSET__48916cb1__"